module.exports = __webpack_public_path__ + "static/media/ph_animated.6d7b165e.gif";